export default __webpack_public_path__ + "static/media/news-in.b5271c0e.mp3";